import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const EarningsCodesPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'description', label: 'Description' },
    { key: 'type', label: 'Earnings Type' },
    { key: 'taxable', label: 'Taxable' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'text', required: true },
    { key: 'type', label: 'Earnings Type', type: 'select', required: true, options: [
      { value: 'Regular', label: 'Regular Pay' },
      { value: 'Overtime', label: 'Overtime' },
      { value: 'Bonus', label: 'Bonus' },
      { value: 'PTO', label: 'Paid Time Off' },
      { value: 'Sick', label: 'Sick Leave' },
      { value: 'Holiday', label: 'Holiday Pay' },
      { value: 'Reimbursement', label: 'Reimbursement' },
      { value: 'Other', label: 'Other' },
    ]},
    { key: 'taxable', label: 'Taxable', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]},
    { key: 'glAccount', label: 'GL Account', type: 'text', required: false },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'REG', description: 'Regular Hours', type: 'Regular', taxable: 'Yes', active: 'Yes' },
    { id: '2', code: 'OT', description: 'Overtime Hours (1.5x)', type: 'Overtime', taxable: 'Yes', active: 'Yes' },
    { id: '3', code: 'DOTOT', description: 'Double Time Overtime (2x)', type: 'Overtime', taxable: 'Yes', active: 'Yes' },
    { id: '4', code: 'PTO', description: 'Paid Time Off', type: 'PTO', taxable: 'Yes', active: 'Yes' },
    { id: '5', code: 'SICK', description: 'Sick Leave', type: 'Sick', taxable: 'Yes', active: 'Yes' },
    { id: '6', code: 'HOL', description: 'Holiday Pay', type: 'Holiday', taxable: 'Yes', active: 'Yes' },
    { id: '7', code: 'BONUS', description: 'Performance Bonus', type: 'Bonus', taxable: 'Yes', active: 'Yes' },
    { id: '8', code: 'SIGNBON', description: 'Sign-On Bonus', type: 'Bonus', taxable: 'Yes', active: 'Yes' },
    { id: '9', code: 'MILE', description: 'Mileage Reimbursement', type: 'Reimbursement', taxable: 'No', active: 'Yes' },
    { id: '10', code: 'PHONE', description: 'Cell Phone Allowance', type: 'Reimbursement', taxable: 'No', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Earnings Codes"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Code"
      formFields={formFields}
      apiEndpoint="/setup/earnings-codes"
    />
  );
};

export default EarningsCodesPage;
